/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				// Conversion des attributs de balise "name" en "id" (pour le défilement contrôlé)
				$('#content a').each(function(){
					var name = $(this).attr('name');
					if(name){ $(this).attr('id',name); }
				});
				// Défilement contrôlé de la page
				$('.scrollTo').each(function(){
					var lien = $(this).attr('href');  // On récupère la valeur du href
					$(this).removeAttr("href");  // On supprime le href pour éviter le comportement par défaut du lien
					$(this).click(function() {$.scrollTo(lien,800,{offset:{left: 0, top:-100 }});});  // On recrÃ©e le lien avec la fonction scrollTo
				});
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				// Diaporama d'entête
				var mySwiper = new Swiper ('.swiper-container', {
					loop: true,
					autoplay: 6000,
					speed: 1000,
					loopAdditionalSlides: 5
				});
				// To avoid having a blank space at the end of loop, we bring back the slider to its initial state when the loop is in he middle.
				var refIndex = mySwiper.activeIndex;
				mySwiper.on('onSlideChangeEnd', function () {
					var realIndex = mySwiper.realIndex;
					if(realIndex === 0) {
						mySwiper.slideTo(refIndex, 0);
						mySwiper.startAutoplay();
					}
				});
				// Diaporama des villes
				var featuredCities = new Swiper ('.featured-cities', {
					loop: true,
					autoplay: 6000,
					speed: 1000,
					slidesPerView: 5,
					nextButton: '.next-cities',
					prevButton: '.prev-cities'
				});
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		'page_template_template_calendrier': {
			init: function() {
				// JavaScript to be fired on the home page
				var cityTabs = new Swiper('.city-tabs', {
					speed: 1000,
					slidesPerView: 3,
					slideToClickedSlide: true,
					loop: true
				});
				var calendrierParis = new Swiper('#plages-calendrier-paris', {
					speed: 1000,
					slidesPerView: 1,
					slideToClickedSlide: true,
					loop: true,
					pagination: '.swiper-pagination',
					paginationClickable: true,
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev'
				});
				var calendrierLyon = new Swiper('#plages-calendrier-lyon', {
					speed: 1000,
					slidesPerView: 1,
					slideToClickedSlide: true,
					loop: true,
					pagination: '.swiper-pagination',
					paginationClickable: true,
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev'
				});
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
				$(function() {

					$('.panel-collapse')
						.on('show.bs.collapse', function () {
							$(this).closest('.panel').addClass('active');
						})
						.on('hide.bs.collapse', function () {
							$(this).closest('.panel').removeClass('active');
						});

					// Slider des plages du calendrier
					var $sliderParis = $('#plages-calendrier-paris'),
						$sliderLyon = $('#plages-calendrier-lyon'),
						$sliderImage = new Image();

					$sliderImage.src = $sliderParis.find('.swiper-wrapper').find('.swiper-slide:first-of-type()').find('img').attr('src');

					$sliderImage.onload = function () {

						// Paris
						var sliderParisHeight = $sliderParis.css('height','auto').outerHeight(),
							$voirCalendrierParis = $('.voir-calendrier #voir-paris'),
							showDelay = 0; // Délai initial pour l'apparition du calendrier au clic

						$sliderParis.css({
							'height': 0
						});

						$voirCalendrierParis.on('click', function(e){
							$sliderLyon.animate({
								'height': 0
							}, 300);
							$sliderParis.delay(showDelay).animate({
								'height': sliderParisHeight
							}, 500, function () {
								$('.swiper-nav').removeClass('transparent');
								showDelay = 500; // À partir de maintenant, le délai sera de 500ms pour afficher le calendrier pour permettre au précédent de disparaitre
							});
							$voirCalendrierParis.animate({
								'opacity': .5
							}, 300, function(){
								$voirCalendrierParis.addClass('disabled');
								$voirCalendrierLyon.removeAttr('style').removeClass('disabled');
							});
						});

						// Lyon
						var sliderLyonHeight = $sliderLyon.css('height','auto').outerHeight(),
							$voirCalendrierLyon = $('.voir-calendrier #voir-lyon');

						$sliderLyon.css({
							'height': 0
						});

						$voirCalendrierLyon.on('click', function(e){
							$sliderParis.animate({
								'height': 0
							}, 300);
							$sliderLyon.delay(showDelay).animate({
								'height': sliderLyonHeight
							}, 500, function () {
								$('.swiper-nav').removeClass('transparent');
								showDelay = 500; // À partir de maintenant, le délai sera de 500ms pour afficher le calendrier pour permettre au précédent de disparaitre
							});
							$voirCalendrierLyon.animate({
								'opacity': .5
							}, 300, function(){
								$voirCalendrierLyon.addClass('disabled');
								$voirCalendrierParis.removeAttr('style').removeClass('disabled');
							});
						});
					};
					$sliderImage.onerror = function () {
						console.error("Cannot load image");
						//do something else...
					};

				});

			}
		},
		'page_template_template_annuaire': {
			init: function() {
				// ANNUAIRE
				// Tableau de l'annuaire
				$('table.annuaire')
					.tablesorter({
						sortList: [[3,0]], // On ordonne suivant la dernière colonne (ville)
						headers: {
							0: {
								// On désactive le tri sur la première colonne
								sorter: false
							}
						}
					})
					.on('mouseleave', function(){
						$('.profile-details').remove();
					});

				function displayProfileDetails($this){

					var precisions  = $this.find('td.infos .precisions').clone();

					if (!$this.next('tr').hasClass('profile-details')) {
						$('.profile-details').remove();
						$this
							.addClass('active-profile')
							.after('<tr class="profile-details active-profile"><td colspan="5"></td></tr>');
						$('.profile-details td').append(precisions);
					}

				}

				// Non touch devices
				$('.no-touchevents table.annuaire tbody tr').on('mouseenter', function(){
					var $this = $(this);
					displayProfileDetails($this);
				});
				// Touch devices
				$('.touchevents table.annuaire tbody tr').on('click', function(){
					var $this = $(this);
					displayProfileDetails($this);
				});


				// Changement de pays pour le calendrier
				$('#choixPays').change(function() {
					var lien = $(this).val();  // On rÃ©cupÃ¨re la valeur du select
					$.scrollTo(lien,800,{offset:{left: 0, top:-100 }});  // On recrÃ©e le lien avec la fonction scrollTo
				});


				// Conversion des attributs de balise "name" en "id" (pour le défilement contrôlé)
				$('#content').find('a').each(function(){
					var name = $(this).attr('name');
					if(name){ $(this).attr('id',name); }
				});

			}
		},
		'page_template_template_faq': {
			init: function() {
				// FAQ
				// Questions-Réponses
				$('.question-reponse h5 a').on('click', function() {
					// On cache à nouveau par défaut les réponses
					$('.question-reponse div.reponse').removeAttr('style');
					// On affiche la réponse à la question concernée
					var $reponse = $(this).closest('div').find('.reponse'),
						height = $reponse.css('height', 'auto').height();
					$reponse.css('height', height);
				});
			}
		},
		// About us page, note the change from about-us to about_us.
		'about_us': {
			init: function() {
			// JavaScript to be fired on the about us page
		}
	}
};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
